import md5 from 'md5'
import FileSystemCache from '~/helpers/fileSystemCache'

export default function ({ $axios, $config, $sentry }, inject) {
  const client = $axios.create({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `Bearer ${$config.datoApiToken}`
    }
  })

  const responseCache = new FileSystemCache({
    ttl: $config.datoCacheTTL,
    basePath: './.datocache'
  })

  const readFromCache = async (hash) => {
    if (process.client) return null // Don't use cache clientside
    return await responseCache.get(hash)
  }

  const writeToCache = async (hash, response) => {
    if (process.client) return // Don't use cache clientside
    return await responseCache.set(hash, response)
  }

  const fetch = async ({ query, preview = false }) => {
    if (typeof query !== 'string') throw new Error(`Expected query to be a string, got ${typeof query}`)
    
    const url = preview ? 'https://graphql.datocms.com/preview' : $config.datoEndpoint

    // Check to see if we've got a reponse cached
    const queryHash = md5(`${url}-${query}`)
    const cachedResponse = await readFromCache(queryHash)
    if (cachedResponse) {
      console.log('Using cachedResponse')
      return cachedResponse
    }

    try {
      const result = await client.post(url, { query })
      
      const response = result.data.data || result.data
      if (response.errors) {
        throw new Error(`Unable to query content API. Errors: ${response.errors}`)
      }

      await writeToCache(queryHash, response)
      return response
    } catch (error) {
      console.error(error)
      $sentry.captureException(error)
      throw error
    }
  }
  
  inject('contentAPI', { fetch })
}
